"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredDot = void 0;
const React = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const styled_components_1 = __importDefault(require("styled-components"));
exports.RequiredDot = styled_components_1.default((props) => (React.createElement("span", { className: `${props.className} required-field` }, props.required ? (React.createElement(React.Fragment, null,
    React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: props.className, icon: "circle", transform: props.raised
            ? `shrink-11 ${props.raisedTransform}`
            : `shrink-11 ${props.loweredTransform}` }),
    React.createElement("span", null, props.children))) : (React.createElement("span", null, props.children))))) `
   color: ${props => props.theme["alert-color"]};
   &.required-field {
      margin: 0px;
      padding: 0px;
      white-space: nowrap;
      display: inline-block;
      & svg {
         position: absolute;
         display: inline;
      }
   }
`;
exports.RequiredDot.defaultProps = {
    required: false
};
//# sourceMappingURL=RequiredDot.js.map